export default __webpack_public_path__ + "static/media/personal-video.2dacb849.mp4";